import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  InputNumber,
  Popconfirm,
} from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { CompanyTypes, ReferenceTypeCodes } from "_helpers";
import { companyService, currencyService, referenceService } from "_services";

function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [regions, setRegions] = useState([]);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [businessCategories, setBusinessCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getCurrencies();
    getRegions();
    getCompanyTypes();
    getCountries();
    getBusinessCategories();
    getCompanies();
  }, []);

  const getCurrencies = () => {
    setIsLoading(true);
    currencyService
      .getSuggestion()
      .then((x) => {
        setIsLoading(false);
        setCurrencies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getRegions = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.REGION)
      .then((x) => {
        setIsLoading(false);
        setRegions(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCompanyTypes = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.COMPANY_TYPE)
      .then((x) => {
        setIsLoading(false);
        setCompanyTypes(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCountries = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.COUNTRY)
      .then((x) => {
        setIsLoading(false);
        setCountries(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getBusinessCategories = () => {
    setIsLoading(true);
    referenceService
      .getAllReferenceDataByTypeCode(ReferenceTypeCodes.INDUSTRY_TYPE)
      .then((x) => {
        setIsLoading(false);
        setBusinessCategories(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCompanies = () => {
    setIsLoading(true);
    companyService
      .getSuggestion("")
      .then((x) => {
        setIsLoading(false);
        setCompanies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        values.parent = values?.parent?.id ? values.parent : null;
        values.companyTypes = values.companyTypes.map((id) => ({
          id,
        }));
        companyService
          .create(values)
          .then(() => {
            setIsLoading(false);
            message.success("Successfully created!");
            history.push(".");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Popconfirm
        title="Are you sure to save?"
        onConfirm={handleFormSumbit}
        key="confirm"
      >
        <Button key="1" htmlType="submit" loading={isLoading}>
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const onCancel = () => {
    history.push(".");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies">Company Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies/add">New Company</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="code"
                  label="Company Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input placeholder="Company Code" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="companyTypes"
                  label="Company Types"
                  rules={[
                    { required: true, message: "Company Type is required" },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Please select"
                    mode="multiple"
                  >
                    {companyTypes.length > 0 &&
                      companyTypes.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="vatNo" label="VAT Number">
                  <Input placeholder="VAT Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label="Company Name"
                  rules={[{ required: true, message: "Name is required" }]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name={["region", "id"]} label="Region">
                  <Select placeholder="Please select">
                    {regions.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="importerNo" label="Importer Number">
                  <Input placeholder="Importer Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="alternateCode" label="Alternate Code">
                  <Input placeholder="Alternate Code" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name={["country", "id"]} label="Country">
                  <Select placeholder="Please select">
                    {countries.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="tiepApprovalNo" label="TIEP Approval Number">
                  <Input placeholder="TIEP Approval Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="alternateName" label="Alternate Name">
                  <Input placeholder="Alternate Name" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name={["industryType", "id"]}
                  label="Business Category"
                >
                  <Select placeholder="Please select">
                    {businessCategories.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="tiepSchemeType" label="TIEP Schema Type">
                  <Input placeholder="TIEP Schema Type" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name={["parent", "id"]} label="Parent Company">
                  <Select placeholder="Please select" allowClear>
                    {companies.length > 0 &&
                      companies.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="emails" label="Emails">
                  <Input placeholder="Emails" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="maxPoLines"
                  label="Max PO LinesMaximum PO Lines"
                >
                  <InputNumber placeholder="Maximum PO Lines" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}></Col>
              <Col span={8}></Col>
              <Col span={8}>
                <Form.Item name="minimumOrderValue" label="Minimum Order Value">
                  <InputNumber placeholder="Minimum Order Value" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
